import aksonov from './teamsphoto/aksonov.jpg';
import sukhara from './teamsphoto/sukhra.jpg';
import sharyak from './teamsphoto/sharyak.jpg';
import shkarupa from './teamsphoto/shkarupa.jpg';
import zaharova from './teamsphoto/zaharova.jpg';
import parkhomenko from './teamsphoto/parkhomenko.jpg';
import vovk from './teamsphoto/vovk.jpg';
import krasivoron from './teamsphoto/krasivoron.jpg';
import kurtiak from './teamsphoto/kurtiak.jpg';

const teamGroup = [
  {
    id: '1',
    name: 'Aksonov Yevhen',
    photo: aksonov,
    link: 'https://www.linkedin.com/in/kotiko/',
    role: 'Teamlead',
  },
  {
    id: '2',
    name: 'Viktoriia Sukhara',
    photo: sukhara,
    link: 'https://www.linkedin.com/in/viktoriia-sukhara-31616a288/',
    role: 'Scram master',
  },
  {
    id: '3',
    name: 'Oleksandr Sharyak',
    photo: sharyak,
    link: 'https://www.linkedin.com/in/oleksandr-sharyak-b72a47289/',
    role: 'Developer',
  },
  {
    id: '4',
    name: 'Konstantin Shkarupa',
    photo: shkarupa,
    link: 'https://www.linkedin.com/in/konstantin-shkarupa/',
    role: 'Developer',
  },
  {
    id: '5',
    name: 'Kate Zaharova',
    photo: zaharova,
    link: 'https://www.linkedin.com/in/kate-zaharova',
    role: 'Developer',
  },
  {
    id: '6',
    name: 'Anastasiia Parkhomenko',
    photo: parkhomenko,
    link: 'https://www.linkedin.com/in/anastasiia-parkhomenko-dev/',
    role: 'Developer',
  },
  {
    id: '7',
    name: 'Igor Volk',
    photo: vovk,
    link: 'https://www.linkedin.com/in/igor-volk/',
    role: 'Developer',
  },
  {
    id: '8',
    name: 'Liudmyla Krasivoron',
    photo: krasivoron,
    link: 'https://github.com/lusya0409',
    role: 'Developer',
  },
  {
    id: '9',
    name: 'Ania Kurtiak',
    photo: kurtiak,
    link: 'https://www.linkedin.com/in/anna-kurtiak-a30400143/',
    role: 'Developer',
  },
];

export default teamGroup;
